<template>
  <a-table :columns="columns" :scroll="{x: 680,y:500}" :data-source="list" class="tableBox" rowKey='name' :pagination="false">
     <template
    v-for="col in ['price','percentage','uasge','maxValue', 'minValue','maxShadowPrice','cost','minApply','maxApply','minLimitValue','maxLimitValue','minShadowPrice']"
    :slot="col"
    slot-scope="text"
  >
  {{ text === '' || text === null || text === undefined ? text : Number(text).toFixed(3)}}
  </template>
  </a-table>
</template>
<script>
export default {
  props:{
    rowId:{
      type: String,
      default: ''
    },
    factoryId:{
      type: String,
      default: ''
    }
  },
  data(){
    return{
      list:[],
      pagination: {
        total:0,
        pageSize:10000,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      columns: [
        {
          title: '原料名称',
          dataIndex: 'rawName',
          width: 150,
          ellipsis: true,
        },
        {
          title: '代码',
          dataIndex: 'rawCode',
          width: 120,
          ellipsis: true,
        },
        {
          title: '价格',
          dataIndex: 'price',
          scopedSlots: {customRender: 'price'},
          width: 100,
          ellipsis: true,
        },
        {
          title: '用量(%)',
          dataIndex: 'percentage',
          scopedSlots: {customRender: 'percentage'},
          width: 100,
          ellipsis: true,
        },
        {
          title: '用量(批次量)',
          dataIndex: 'uasge',
          scopedSlots: {customRender: 'uasge'},
          width: 80,
          ellipsis: true,
        },
        // {
        //   title: '单位',
        //   dataIndex: 'unit',
        //   width: 80,
        //   ellipsis: true,
        // },
        {
          title: '最小值',
          dataIndex: 'minValue',
          scopedSlots: {customRender: 'minValue'},
          width: 80,
          ellipsis: true,
        },
        {
          title: '最大值',
          dataIndex: 'maxValue',
          width: 80,
          scopedSlots: {customRender: 'maxValue'},
          ellipsis: true,
        },
        {
          dataIndex:'minShadowPrice',
          title:'影子价格下限',
          scopedSlots: {customRender: 'minShadowPrice'},
          ellipsis:true,
          width:140
        },
        {
          dataIndex:'maxShadowPrice',
          title:'影子价格上限',
          scopedSlots: {customRender: 'maxShadowPrice'},
          ellipsis:true,
          width:140
        },
        {
          dataIndex:'cost',
          title:'单位成本',
          scopedSlots: {customRender: 'cost'},
          ellipsis:true,
          width:120
        },

        {
          dataIndex:'minApply',
          title:'适用下限',
          scopedSlots: {customRender: 'minApply'},
          ellipsis:true,
          width:120
        },
        {
          dataIndex:'maxApply',
          title:'适用上限',
          scopedSlots: {customRender: 'maxApply'},
          ellipsis:true,
          width:100
        },
        {
          dataIndex:'minLimitValue',
          key:'minLimitValue',
          scopedSlots: {customRender: 'minLimitValue'},
          title: '极下限',
          ellipsis:true,
          width:120
        },
        {
          dataIndex:'maxLimitValue',
          key:'maxLimitValue',
          scopedSlots: {customRender: 'maxLimitValue'},
          title:'极上限',
          ellipsis:true,
          width:120
        },
      ],
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    getList(){
      // let {current=1,pageSize=10000} = pagination || this.pagination
      let params = {
        formulaId:this.rowId,
        factoryId:this.factoryId,
        // current,size:pageSize
      }
      console.log(params)
      if(this.rowId){
        this.$http.get('/nhf-app/archivedFormula/formulaRawList',{params}).then(res => {
          let {success,data} = res;
          if(success){
            //过滤赶紧data 中 isDeleted	为 1 的数据，并根据percentage 排序
            this.list = data
                .filter(item => item.isDeleted !== 1)
                .sort((a, b) => b.percentage - a.percentage);
          }else{
            this.$message.error('查询失败')
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.tableBox{
  padding: 0 20px;
}
</style>
